module.exports = __webpack_public_path__ + "static/media/home.435fe584.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home.svg
 ** module id = 609
 ** module chunks = 0
 **/